import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing: Promise<unknown> | null = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url: string = cfg.url || "";
    const skip = url.includes("/auth/login") || url.includes("/auth/refresh");
    if (error.response?.status === 401 && !cfg._retry && !skip) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        /* fall through */
      }
    }
    return Promise.reject(error);
  },
);

export const fileUrl = (path?: string | null) => (path ? `${API}/files/${path}` : "");

export function formatApiError(e: any): string {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (typeof d?.msg === "string" ? d.msg.replace(/^Value error, /, "") : JSON.stringify(d))).join(" ");
  return typeof detail?.msg === "string" ? detail.msg : String(detail);
}

export async function downloadBlob(url: string, filename: string, body?: unknown) {
  const res = body ? await api.post(url, body, { responseType: "blob" }) : await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}
